import React, { useEffect, useState, useRef } from "react";
import gsap from "gsap";
import Burger from "../components/Pictos/Burger";

import styles from "./Navigation.module.scss"
import isMobile from "ismobilejs";
import LazyLoad from "../LazyLoad";


export default function Navigation () {
    const [nav, setNav] = useState(null);
    const [opened, setOpened] = useState(false);

    const animation = useRef(null);
    const navigation = useRef(null);

    useEffect(() => {
        const navArray = [];
        const sections = document.querySelectorAll('.navigation--1');

        Object.values(sections).map((section, index) => {
            navArray.push({
                section: section.querySelector('h2, .subtitle').innerText.split('(')[0],
                items: []
            });

            const subNav = section.querySelectorAll('.navigation--2');

            Object.values(subNav).map(item =>
                navArray[index].items.push(item.querySelector('h3').innerHTML)
            );

            return true;
        });

        window.addEventListener('scroll', () => {
            if (sections[0].getBoundingClientRect().left <= window.outerWidth / 3) {
                setOpened(false);
            }
        });

        setNav(() => navArray);
    }, []);

    useEffect(() => {
        gsap.set('.App', {
            overflowX: opened ? 'hidden' : 'visible'
        });

        gsap.to(navigation.current, .3, {
            opacity: opened ? 1 : 0
        });

        animation.current?.kill();


        if (opened) {
            animation.current = gsap.set('section', {
                position: 'relative',
                onComplete: () => {
                    gsap.to(document.querySelectorAll('section, header'), .8, {
                        left: isMobile().phone ? '70vw' : '50vw'
                    })
                }
            })

        } else {
            animation.current = gsap.to(document.querySelectorAll('section, header'), .8, {
                left: 0,
                onComplete: () => {
                    gsap.set('section', {
                        clearProps: 'position'
                    })
                }
            })
        }
    }, [opened]);

    const handeScrollClick = (section, article) => {
        const sectionEl = document.querySelectorAll('.navigation--1')[section];
        const articleEl = sectionEl.querySelectorAll('.navigation--2')[article];

        const scrollEl = articleEl ?? sectionEl;
        let rect = scrollEl.getBoundingClientRect();

        const images = document.querySelectorAll('img[data-src]');

        Object.values(images).map(image => {
            const imageRect = image.getBoundingClientRect();

            if (imageRect.bottom < rect.bottom) {
                LazyLoad(image);

                setTimeout(() => rect = scrollEl.getBoundingClientRect(), 500)
            }

            return  true;
        });

        setTimeout(() => {
            window.scrollTo({top: rect.top + window.scrollY,  behavior: 'smooth'});
        }, 1000)
    };

    return (
        <>
            <button className={styles.Button} onClick={() => setOpened(prev => !prev)}>
                <Burger opened={opened}/>
            </button>

            <nav className={styles.Navigation} ref={navigation}>
                <span className={styles.Title} >
                    5G
                </span>
                <ol>
                    {
                        nav ? nav.map((item, index) =>
                            <li key={index} className={item.items.length > 0 ? 'has--children' : ''}>
                                <span className={styles.Section} onClick={() => handeScrollClick(index)}>{item.section}</span>

                                {
                                    item.items ?
                                        <ol>
                                            {
                                                item.items.map((listItem, listIndex) =>
                                                    <li key={listIndex} onClick={() => handeScrollClick(index, listIndex)}>
                                                        {listItem}
                                                    </li>
                                                )
                                            }
                                        </ol>
                                    : null
                                }
                            </li>
                        ) : null
                    }
                </ol>
            </nav>
        </>
    )
}
